import React from 'react';
import '../hop_category/HopCategory.css';
import ReusableHopCategory from '../reusable/ReusableHopCategory';
import Reusablehop_category_brand_main from '../reusable/Reusablehop_category_brand_main';
import Reusablehop_category_price_three from '../reusable/Reusablehop_category_price_three';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row } from 'react-bootstrap';

const HopCategory = () => {
  return (
    <>
      <section id="hop_category">
        <Container>
          <Row>
            <Col lg={12}>
              <Row style={{ rowGap: '25px' }}>
                <Col lg={4}>
                  <form className="d-flex" role="search">
                    <input className="form-control me-2" type="search" placeholder="Search products" aria-label="Search" />
                    <button className="btn btn-outline-success" type="submit">Search</button>
                  </form>
                </Col>
                <Col lg={4} xs={8} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", height: "100%" }}>
                  <p className="placeholder-text">Showing 1-15 of 30 results</p>
                </Col>
                <Col lg={1} xs={3}>
                  <div className="placeholder-menu">
                    <div className="placeholder-menu-icon"><i className="fa-solid fa-bars-progress"></i></div>
                    <div className="placeholder-menu-icon"><i className="fa-solid fa-bars-staggered"></i></div>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="dropdown">
                    <Form.Select aria-label="Default select example">
                      <option>Sort by latest</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </Form.Select>
                    <ul className="dropdown-menu">
                      <li><a className="dropdown-item" href="#">Action</a></li>
                      <li><a className="dropdown-item" href="#">Another action</a></li>
                      <li><a className="dropdown-item" href="#">Something else here</a></li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col className='pt-4' lg={12}>
              <Row>
                <Col lg={12}>
                  <Row>
                    <Col lg={3}>
                      <Row>
                        <Col lg={12}>
                          <div className="hop_category_menu">
                            <h2 className='text-center'>Related Categories</h2>
                            <div className="hop_category_menu-div"></div>
                            <div className="hop_category_menu_main">
                              <ul>
                                <li>Beverages (5)</li>
                                <li>Butter & Eggs (9)</li>
                                <li>Dried</li>
                                <li>Food (6)</li>
                                <li>Fresh Meat</li>
                                <li>Fruits (6)</li>
                                <li>Juice</li>
                                <li>Vegetables (25)</li>
                                <li>Meats</li>
                                <li>Supplements (6)</li>
                              </ul>
                            </div>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="hop_category_price">
                            <h2>Price</h2>
                            <div className="hop_category_menu-div"></div>
                            <div className='hop_category_price_form'>
                              <div className='text-center'>
                                <input type="range" className="form-range" min="0" max="5" step="0.5" id="customRange3" />
                              </div>
                              <label htmlFor="customRange3" className="form-label">Range: $50 - $150</label>
                            </div>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="hop_category_brand">
                            <h2>Brand</h2>
                            <div className="hop_category_menu-div"></div>
                            <div className="hop_category_brand_main">
                              <ul>
                                <Reusablehop_category_brand_main icon={"fa-solid fa-star"} />
                                <Reusablehop_category_brand_main color={'#E1E1E1'} />
                                <Reusablehop_category_brand_main />
                                <Reusablehop_category_brand_main />
                                <Reusablehop_category_brand_main />
                              </ul>
                            </div>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="hop_category_price_three">
                            <h1>Best Seller</h1>
                            <Reusablehop_category_price_three img={"/imeges/Desktop - 5/orange-icon.svg"} title="Organic Juice" />
                            <Reusablehop_category_price_three img={"/imeges/Desktop - 5/brocly-icon.svg"} title="Fresh Vegetable" />
                            <Reusablehop_category_price_three img={"/imeges/Desktop - 5/jamun icon.svg"} title="Organic Cabbage" />
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className='hop_category_price_four'>
                            <h1>Tags</h1>
                            <div className="hop_category_price_four_menu">
                              <button type="button" className="btn btn-outline-secondary">Apple</button>
                              <button type="button" className="btn btn-outline-secondary">Bread</button>
                              <button type="button" className="btn btn-outline-secondary">Cheese</button>
                              <button type="button" className="btn btn-outline-secondary">Fruits</button>
                              <button type="button" className="btn btn-outline-secondary">Fish</button>
                              <button type="button" className="btn btn-outline-secondary">Organic</button>
                              <button type="button" className="btn btn-outline-secondary">Vegetable</button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={9} className='pt-4'>
                      <Row style={{ rowGap: '20px' }}>
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-strowbarry.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-orange.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-avocado.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-avocado.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-tamoto.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-brocly.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-jamun.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-red.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-lamon.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-licu.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-avocado-small.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-brocly green.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-Apricot.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-strowbarry red.svg" />
                        <ReusableHopCategory img="imeges/Desktop - 5/Categories-banga.svg" />
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col lg={12}></Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default HopCategory;
